import { Organization } from './';
import { AWARDS_LATAM } from '../awards/latam';
import { getLatamDictionary } from '../languages/latam';

// The shared Organization (US) describes Loadsmart as a TMS plus freight
// brokerage. In LATAM we are Loadsmart AI + Opendock, so the description comes
// from the About page copy of each market. These are copies: the shared
// Organization object is never modified.
export const getOrganizationLatam = (locale) => ({
  ...Organization,
  description: getLatamDictionary(locale).about.meta_description,
});

// About page: same shape as ./awards.js but built from the LATAM awards list.
export const getAwardsLatam = (locale) => ({
  ...getOrganizationLatam(locale),
  awards: AWARDS_LATAM.flatMap((year) =>
    year.awards.map((award) => `${year.year} ${award.name}`)
  ).join(','),
});
